import Vue from "vue";
import App from "./App";
import router from "@/_shared/router";

import Notifications from "vue-notification";
import Popover from 'vue-js-popover';

import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd';
import {
  uniLayerGroupMonochrome,
  uniAward,
  uniAwardAlt,
  uniMedal,
  uniTrophy,
  uniThumbsUp,
  uniThumbsDown,
  uniStar,
  uniCoins,
  uniGrin,
  uniSmile,
  uniCheck,
} from 'vue-unicons/dist/icons';

Unicon.add([
  uniLayerGroupMonochrome,
  uniAward,
  uniAwardAlt,
  uniMedal,
  uniTrophy,
  uniThumbsUp,
  uniThumbsDown,
  uniStar,
  uniCoins,
  uniGrin,
  uniSmile,
  uniCheck,
]);
Vue.use(Unicon);

Vue.use(Notifications);
Vue.use(Popover);
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js